import React from 'react';
import Footer from '../../../layout/Footer/Footer';
import Popovers from '../../../components/bootstrap/Popovers';

const DefaultFooter = () => {
	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col-auto text-center w-100'>
						<code className=''>JsPay BackOffice © 2024</code>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
